import "./obstruction"
import "./import_jquery";
import "jquery";

import "jquery-ujs";
import "katex/dist/katex.min.js";
import "katex/dist/contrib/auto-render.min.js";
import "slick-carousel/slick/slick.min.js";
import "salvattore/dist/salvattore.min.js";
import "suneditor/dist/suneditor.min.js";

import "./providers/detect_resize.js";
import "./modules/components/aha_area.js";
import "./modules/components/aha_buttons.js";
import "./modules/components/carousel.js";
import "./modules/components/question_card_list.js";
import "./modules/components/register.js";
import "./modules/layouts/header.js";
import "./modules/layouts/register.js";
import "./modules/utilities/alt_text.js";
import "./modules/utilities/dummy_links.js";
import "./projects/about.js";
import "./projects/keyword.js";
import "./projects/welcome.js";
import "./www/faq.js";
import "./www/tracking.js";
